import { html } from 'lit';
import { Calendar } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-calendar')
export class PdsIconCalendar extends PdsIcon {
  @state()
  icon = Calendar;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
